import React from 'react';
import PropTypes from 'prop-types';

export default class AccountControls extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    onResetPassword: PropTypes.func.isRequired,
  }

  onResetPassword = () => {
    if (window.confirm('Do you really want to reset password for this adult?')) {
      const { account, onResetPassword } = this.props;
      onResetPassword(account.id, account.email);
    }
  }

  render() {
    return (
      <div className='row'>
        <div className='column small-12 u-margin-bottom--small'>
          <a className='o-sp-button o-sp-button--primary o-sp-button--expanded' onClick={this.onResetPassword}>Reset Password</a>
        </div>
      </div>
    )
  }
}
